import CryptoJS from 'crypto-js'
import {JSEncrypt} from 'jsencrypt'

const iv = CryptoJS.enc.Utf8.parse('0112030445060709')

const rsa = new JSEncrypt()

function encryptByMD5 (message, key = '') {
  return CryptoJS.MD5(message + key).toString()
}

// DES加密
function encryptByDES (message, key) {
  if (typeof message === 'object') {
    message = JSON.stringify(message)
  }
  const KeyHex = CryptoJS.enc.Hex.parse(key)
  const data = CryptoJS.enc.Utf8.parse(message)
  const encrypted = CryptoJS.DES.encrypt(data,
    KeyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.ZeroPadding
    })
  return encrypted.ciphertext.toString()
}

// DES解密
function decryptByDES (ciphertext, key) {
  const KeyHex = CryptoJS.enc.Hex.parse(key)
  const decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Hex.parse(ciphertext)
  }, KeyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.ZeroPadding
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// 3DES加密
function encryptBy3DES (message, key) {
  if (typeof message === 'object') {
    message = JSON.stringify(message)
  }
  const KeyHex = CryptoJS.enc.Hex.parse(key)
  const data = message
  const encrypted = CryptoJS.TripleDES.encrypt(data, KeyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.ZeroPadding
  }).ciphertext
  return encrypted.toString()
}

// 3DES解密
function decryptBy3DES (ciphertext, key) {
  const KeyHex = CryptoJS.enc.Hex.parse(key)
  const decrypted = CryptoJS.TripleDES.decrypt({
    ciphertext: CryptoJS.enc.Hex.parse(ciphertext)
  }, KeyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.ZeroPadding
  })
  // return decrypted.toString()
  // console.log(decrypted)
  // console.log(decrypted.toString())
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// AES加密
function encryptByAES (str, key) {
  const hexStr = CryptoJS.AES.encrypt(
    str,
    CryptoJS.enc.Utf8.parse(key.slice(0, 16).padStart(16, '0')),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  ).ciphertext.toString().toUpperCase()
  const oldHexStr = CryptoJS.enc.Hex.parse(hexStr)
  return CryptoJS.enc.Base64.stringify(oldHexStr)
}

// AES解密
function decryptByAES (str, key) {
  return CryptoJS.AES.decrypt(
    str,
    CryptoJS.enc.Utf8.parse(key.slice(0, 16).padStart(16, '0')),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  ).toString(CryptoJS.enc.Utf8)
}

function encryptByRSA (str, key) {
  rsa.setPublicKey(key)
  return rsa.encrypt(str).toString()
}

export {
  encryptByDES,
  decryptByDES,
  encryptByMD5,
  encryptBy3DES,
  decryptBy3DES,
  encryptByAES,
  decryptByAES,
  encryptByRSA
}



// WEBPACK FOOTER //
// ./src/util/EncryptionAndDecryption.js